export const entityErrorMessages = {
  ENTITY_NOT_FOUND: 'Entity not found',
  INVALID_UUID: 'invalid input syntax for type uuid',
};
